import SpecialCarousel from './components/SpecialCarousel';
import SpecialImage from './components/SpecialImage';
var variantMap = {
  "default": SpecialImage,
  carousel: SpecialCarousel
};
export default variantMap;